import React from 'react'
import { AboutUs } from '../templates/Home/aboutUs'
import ClientReview from '../templates/Home/clientReview'
import LatestJobs from '../templates/Home/latestJobs'
import { MainBanner } from '../templates/Home/mainBanner'
import HomeMission from '../templates/Home/mission'
// import { OurPartners } from '../templates/Home/ourPartners'
import WhyUs from '../templates/Home/whyUs'
import ActiveHiring from '../templates/Home/activeHiring'

export const HomePage = () => {
  return (
    <div>
        <MainBanner />
        <ActiveHiring />
        <AboutUs />
        <WhyUs />
        <HomeMission />
        <LatestJobs />
        <ClientReview />
        {/* <OurPartners /> */}
    </div>
  )
}
